import { Currency } from "../common";
import { Customer } from "../customer";
import { AccountIntegration } from "../accountIntegration";
import { AccountDomain } from "../accountDomain";

/**
 * Entidad Order
 * Define la orden de compra de un cliente en el sitio web.
 */

export interface Order {
    id: string;
    accountId: string;
    customerId: string;
    cartId?: string;
    code: string;
    deliveryType?: OrderDeliveryType;
    deliveryFirstName?: string;
    deliveryLastName?: string;
    deliveryAddress?: any;
    deliveryPhone?: any;
    deliveryOptionId?: string;
    pickupBranchId?: string;
    paymentMethodIntegrationId?: string;
    billingInformation?: any;
    currency: Currency;
    subtotalPrice: number;
    totalDiscounts: number;
    totalShippingPrice: number;
    totalTax: number;
    taxDetails?: any;
    totalPrice: number;
    totalRefunded: number;
    status: OrderStatus;
    paymentStatus: OrderPaymentStatus;
    fulfillmentStatus: OrderFulfillmentStatus;
    statusHistory?: StatusChangeHistory[];
    customerNote?: string;
    internalNote?: string;
    source: OrderSource;
    sourceAccountDomainId?: string;
    demo: boolean;
    createdAt: Date;
    updatedAt: Date;
    cancelledAt?: Date;
    cancelReason?: string;
    deletedAt?: Date;
    items?: OrderItem[];

    customer?: Customer | null;
    paymentMethodIntegration?: AccountIntegration | null;
    accountDomain?: AccountDomain;
}

export interface OrderItem {
    id: string;
    accountId: string;
    orderId: string;
    productId: string;
    productVariantId: string;
    sku?: string;
    productName: string;
    variantName?: string;
    currency: Currency;
    unitPrice: number;
    totalDiscount: number;
    totalPrice: number;
    quantity: number;
    quantityFulfilled: number;
    quantityRefunded: number;
    quantityReturned: number;
    totalTax: number;
    taxName?: string;
    createdAt: Date;
    updatedAt: Date;
}

export enum OrderStatus {
  PENDING = 'PENDING', // Order placed, awaiting payment confirmation
  CONFIRMED = 'CONFIRMED', // Payment received, order confirmed
  PROCESSING = 'PROCESSING', // Order being prepared
  PROCESSED = 'PROCESSED', // Order ready to be shipped
  ON_HOLD = 'ON_HOLD', // Order temporarily paused
  COMPLETED = 'COMPLETED', // Order finished (e.g., after return period)
  CANCELLED = 'CANCELLED', // Order cancelled before fulfillment
  FAILED = 'FAILED', // Order failed (e.g., payment failed irrecoverably)
}

export enum OrderPaymentStatus {
    PENDING = 'PENDING',
    PARTIAL = 'PARTIAL',
    PAID = 'PAID',
    OVERPAID = 'OVERPAID',
    REFUNDED = 'REFUNDED',
    PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED'
}

export enum OrderFulfillmentStatus {
    PENDING = 'PENDING',
    PARTIAL = 'PARTIAL',
    FULFILLED = 'FULFILLED'
}

export enum OrderSource {
    WEB = 'WEB',
    POS = 'POS',
    API = 'API'
}

export enum OrderDeliveryType {
    SHIPPING = 'shipping',
    PICKUP = 'pickup',
}

export interface StatusChangeHistory {
    status: OrderStatus;
    timestamp: Date;
    reason?: string;
    userId?: string;
    metadata?: Record<string, any>;
}